import {Pipe, PipeTransform} from "@angular/core";
import {DomSanitizer} from "@angular/platform-browser";


@Pipe({name: 'temaUrl'})
export class TemaUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(value) : any {
    if(value){
      return this.sanitizer.bypassSecurityTrustResourceUrl('assets/css/themes/'+value+'.css');
    }else{
      return this.sanitizer.bypassSecurityTrustResourceUrl('#');
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/pipes/tema-url.pipe.ts